import dynamic from "next/dynamic";
const HubspotFormComponent = dynamic(()=>import("./hubspot-form-component"));
import HubspotFormConfig from "./hubspot-form-config";
import HubspotFormAdvancedConfig from "./hubspot-form-advanced-config";
export default {
    HubspotFormComponent,
    HubspotFormConfig,
    HubspotFormAdvancedConfig
};
